import {assertUnreachable} from '@aboutyou/utils';
import React, {useMemo} from 'react';
import {PersonalisedBadge} from '../types';
import {Badge, BadgeProps} from './GenericBadges';

export const PersonalizedBadge: React.FC<
  BadgeProps & {
    type: PersonalisedBadge;
  }
> = ({type, ...badgeProps}) => {
  const emoji = useMemo(() => {
    switch (type) {
      case 'favorite':
        return '❤️';
      case 'oftenBought':
        return '🔥';
      case 'recommended':
        return '👌';
      default:
        assertUnreachable(type);
    }
  }, [type]);

  return <Badge {...badgeProps} emoji={emoji} />;
};
